import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { absenceReasonUnion, requiredString } from '@/utils/zod'

const planAbsenceSchema = () =>
  z.object({
    student: requiredString(),
    semester: requiredString(),
    attachments: z.array(z.string()),
    attendances: z.array(z.string()),
    notifier_comment: z.string().optional(),
    send_for_guardian_review: z.boolean(),
    reason: absenceReasonUnion.optional()
  })

type PlanAbsence = z.infer<ReturnType<typeof planAbsenceSchema>>

const usePlanAbsence = ({
  onSuccess,
  onError
}: {
  onSuccess: (payload: PlanAbsence) => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: PlanAbsence) =>
      httpService.panel.panelAbsencesRequestsCreate(data),
    onSuccess: (_, data) => onSuccess?.(data),
    onError
  })

export default usePlanAbsence
